var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PollMultipleResultsBar"},[_c('PollResultsChartBar',{attrs:{"chart-bar-data":_vm.chartData,"max":100,"data-label-callback":_vm.dataLabel,"tooltip-label-callback":_vm.tooltipLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }